<template>
  <a
    :href="link"
    class="e4s-hyperlink--100"
    :class="withInputCss"
    :style="getLinkOptionStyles"
    @click.prevent="onClicked"
    ><span v-text="linkText"></span
  ></a>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType, type SetupContext } from 'vue'
import { useConfigController } from '@/config/useConfigStore'

export interface PrimaryLinkOptions {
  widthFitContent: boolean //  If true, the width of the link will be fit to the content.
  // If false, the width will be 100%, e.g. in a Tab or something where makes sense to have the width 100%.
}

/*
 * This component is used to navigate back to the previous page.
 * If you want a click, bind it to this component from parent component.
 */
export default defineComponent({
  name: 'PrimaryLink',
  components: {},
  props: {
    linkText: {
      type: String,
      default: 'SET_LINK_TEXT'
    },
    link: {
      type: String,
      default: '#'
    },
    target: {
      type: String,
      default: '_self'
    },
    linkOptions: {
      type: Object as PropType<PrimaryLinkOptions>,
      default: () => {
        return {
          widthFitContent: true
        }
      }
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(
    props: {
      linkText: string
      link: string
      target: string
      linkOptions: PrimaryLinkOptions
      isDisabled: boolean
    },
    context: SetupContext
  ) {
    const configController = useConfigController()

    const withInputCss = computed(() => {
      const cssEnv = configController.getCssEnvSuffix.value //  E.g. AAI = "ai-", UK = ""  e4s-hyperlink--ia-primary

      const cssClasses = []
      if (props.isDisabled) {
        cssClasses.push('e4s-hyperlink--disabled')
      }
      cssClasses.push('e4s-hyperlink--' + cssEnv + 'primary')

      console.log('withInputCss', cssClasses)
      return cssClasses

      // return ['e4s-hyperlink--' + cssEnv + 'primary']
    })

    function onClicked() {
      console.log('PrimaryLink.onClicked()')
      if (props.isDisabled) {
        return
      }


      context.emit('onClick')

      if (props.link === '#') {
        return
      }

      window.open(props.link, '_blank')
      return
    }

    const getLinkOptionStyles = computed(() => {
      const styles: string[] = []
      if (props.linkOptions.widthFitContent) {
        styles.push('width: fit-content')
      }
      return styles.join(';')
    })

    return { withInputCss, onClicked, getLinkOptionStyles }
  }
})
</script>

<style scoped>
.e4s-hyperlink--disabled {
  color: black;
  cursor: not-allowed;
  text-decoration: none;
}
</style>
